///<reference path="AppKitchen.Controls.Menus.VerticalMenu.ts"/>

module AppKitchen {

    export module Controls {

        export module Menus {

            export class VerticalMenuWrapper extends VerticalMenu {
                
            }

            // ReSharper disable once InconsistentNaming
            export interface CombinedVerticalMenuItem {
                id: string;

                setTarget(el: HTMLElement);
                render();
            }

            // ReSharper disable once InconsistentNaming
            export interface CombinedVerticalAttributes extends AppKitchen.ModelBaseAttributes {
                selectedItem?: string;
            }

            export class CombinedVerticalMenuModel extends AppKitchen.ModelBase<CombinedVerticalAttributes> {
                
            }

            // ReSharper disable once InconsistentNaming
            export interface CombinedVerticalMenuViewOptions extends AppKitchen.ViewBaseOptions {
                menuItems: CombinedVerticalMenuItem[],
            }

            export class CombinedVerticalMenuView extends AppKitchen.ViewBase<CombinedVerticalMenuModel> {
                options: CombinedVerticalMenuViewOptions;

                constructor(model: SearchMenuModel, target: HTMLElement, options?: CombinedVerticalMenuViewOptions) {
                    super(model, target, options);
                    this.options = options;

                    this.setTemplate(AppKitchen.Templates.CombinedVerticalMenu);

                    this.render();
                }

                render() {
                    var index = 0;
                    for (let menuItem of this.options.menuItems) {
                        menuItem.id = `MenuItem_${index++}`;
                    }

                    this.renderTemplate({ items: this.options.menuItems });

                    index = 0;
                    for (let menuItem of this.options.menuItems) {
                        var e = this.$el.find(`#${index++}`)[0];
                        menuItem.setTarget(e);
                        menuItem.render();
                    }
                }
            }
/*
            // ReSharper disable once InconsistentNaming
            export interface MenuItem {
                id: string;
                label: string;
                reference?: any;
                description?: string;
            }

            // ReSharper disable once InconsistentNaming
            export interface VerticalMenuOptions {
                sort?: boolean;
                routingParameter?: string;
                routingHistory?: boolean;
                tooltip?: boolean | ((menuItem: MenuItem) => string);
                documentTitleBase?: string;
                customScroller?: boolean;
                autoSelect?: boolean;
            }

            // ReSharper disable once InconsistentNaming
            export interface VerticalMenuAttributes {
                selectedItem?: string;
            }

            // ReSharper disable once InconsistentNaming
            export interface VerticalMenuFilterOptions {
                operator?: "AND" | "OR";
                noResultsMessage?: string;
            }

            export class VerticalMenu extends AppKitchen.ModelBase<VerticalMenuAttributes> {
                menuItems: MenuItem[];
                menuItemsDict: {[id: string]: MenuItem};
                el: HTMLElement;
                $el: JQuery;
                options: VerticalMenuOptions;
                scroller: HTMLElement;

                constructor(targetContainer: HTMLElement, menuItems: MenuItem[], options?: VerticalMenuOptions) {
                    super({
                        selectedItem: ""
                    });

                    this.options = AppKitchen.OptionsHelper.merge(options, {
                        sort: false,
                        customScroller: true,
                        tooltip: null,
                        routingParameter: null,
                        routingHistory: options && !!options.routingParameter,
                        documentTitleBase: null,
                        autoSelect: true
                    });

                    if (this.options.sort) {
                        menuItems.sort((a, b) => a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1);
                    }

                    if (!menuItems || menuItems.length === 0) {
                        console.log("Menu items not defined or empty");
                        return;
                    }

                    this.menuItems = menuItems;
                    this.updateMenuItemsDict();
                    this.el = targetContainer;
                    this.$el = $(targetContainer);

                    AppKitchen.UIHelper.renderTemplateTo(this.el, AppKitchen.Templates.VerticalMenu, { items: this.menuItems });

                    this.updateScroller();

                    if (this.options.tooltip) {
                        this.$el.find("li").each((i, e) => {
                            if (typeof this.options.tooltip === "function") {
                                var tooltipContent = (<(menuItem: MenuItem) => string>this.options.tooltip)(menuItems[i]);
                                if (tooltipContent) {
                                    $(e).kendoTooltip({
                                        position: "right",
                                        content: tooltipContent,
                                        show: e => AppKitchen.UIHelper.hideTooltips(e.sender)
                                    });
                                }
                            } else if (this.options.tooltip === true && menuItems[i].description) {
                                $(e).kendoTooltip({
                                        position: "right",
                                        content: menuItems[i].description,
                                        show: e => AppKitchen.UIHelper.hideTooltips(e.sender)
                                    });
                            }
                        });
                    }

                    this.bind("change:selectedItem", () => this.highlightSelected());

                    if (this.options.autoSelect) {
                        if (!this.trySetSelectedItemFromUrlQuery()) {
                            var firstItem = this.$el.find("li[data-id]").first();
                            if (firstItem) {
                                this.set({ selectedItem: firstItem.attr("data-id") });
                                this.updateRoute(firstItem.attr("data-id"), false);
                            }
                        }
                    }

                    this.$el.find("li[data-id]").click(e => this.onClick(e));
                }

                clearSelection(options?: AppKitchen.BrowserHelper.RedirectOptions) {
                    this.set({ selectedItem: null });
                    if (this.options.routingParameter) {
                        AppKitchen.BrowserHelper.UrlQuery.removeParameter(this.options.routingParameter, AppKitchen.OptionsHelper.merge(options, {
                            push: false,
                            refresh: false
                        }));
                    }
                }

                protected updateMenuItemsDict() {
                    this.menuItemsDict = {};
                    if (this.menuItems) {
                        this.menuItems.forEach(item => {
                            this.menuItemsDict[item.id] = item;
                        });
                    }
                }

                protected updateScroller() {
                    if (this.options.customScroller) {
                        AppKitchen.UIHelper.Scrolling.customScroller(this.$el.find(".a-vertical-menu-wrapper")[0]);
                        this.scroller = this.$el.find(".a-vertical-menu")[0];
                    } else {
                        this.scroller = this.$el.find(".a-vertical-menu-wrapper")[0];
                    }
                }

                onClick(e: JQueryEventObject) {
                    var selectedId = $(e.target).attr("data-id");
                    if (selectedId) {
                        this.set({ selectedItem: selectedId });
                        this.updateRoute(selectedId, true);
                    }
                }

                protected updateRoute(selectedId: string, history: boolean) {

                    if (this.options.routingParameter && AppKitchen.BrowserHelper.UrlQuery.getParameters()[this.options.routingParameter] !== selectedId) {
                        AppKitchen.BrowserHelper.UrlQuery.setParameter(this.options.routingParameter, selectedId, { push: history && this.options.routingHistory });
                    }

                    if (this.options.documentTitleBase) {
                        var selectedLabel = this.$el.find("li.a-selected").text();
                        document.title = selectedLabel + " - " + this.options.documentTitleBase;
                    }
                }

                protected trySetSelectedItemFromUrlQuery() {
                    var urlQuery = AppKitchen.BrowserHelper.UrlQuery.getParameters();
                    var parameter = urlQuery[this.options.routingParameter];
                    if (this.options.routingParameter && parameter) {
                        if (this.menuItemsDict[parameter]) {
                            this.set({ selectedItem: parameter });
                            this.updateRoute(parameter, false);
                            return true;
                        }
                    }
                    return false;
                }

                protected highlightSelected() {
                    this.$el.find("li").removeClass("a-selected");
                    var selectedId = this.get().selectedItem;
                    if (selectedId) {
                        var el = this.$el.find('li[data-id="' + selectedId + '"]');
                        if (el.length === 1) {
                            el.addClass("a-selected");
                            setTimeout(() => AppKitchen.UIHelper.Scrolling.scrollIntoViewport(el[0], this.scroller), 100);
                        }
                    }
                }

                onSelected(selected: (menuItem: MenuItem) => void) {
                    if (this.get().selectedItem) {
                        selected(this.getSelectedItem());
                    }
                    this.on("change:selectedItem", () => {
                        selected(this.getSelectedItem());
                    });
                }

                getSelectedItem(): MenuItem {
                    if (this.get().selectedItem) {
                        return this.menuItemsDict[this.get().selectedItem];
                    }
                    return null;
                }

                filter(query: string, options?: VerticalMenuFilterOptions) {

                    var filterOptions = AppKitchen.OptionsHelper.merge<VerticalMenuFilterOptions>(options, {
                        operator: "AND",
                        noResultsMessage: undefined
                    });

                    if (filterOptions.noResultsMessage) {
                        this.$el.find(".a-verticalmenu-noresults-message").html(filterOptions.noResultsMessage);
                    }

                    query = query || "";
                    var queries = query.split(" ").AsLinq<string>().Where(q => !!q).Select(q => q.toUpperCase()).ToArray();
                    var $items = this.$el.find("ul.a-vertical-menu > li");

                    if (queries.length === 0) {
                        $items.removeClass("a-hidden");
                    } else {
                        $items.each((i, e) => {
                            var label = $(e).text().toUpperCase();
                            var hit = true;
                            if (filterOptions.operator === "AND") {
                                queries.forEach(query => { if (label.indexOf(query) === -1) { hit = false; } });
                                $(e).toggleClass("a-hidden", !hit);
                            } else {
                                hit = false;
                                queries.forEach(query => { if (label.indexOf(query) !== -1) { hit = true; } });
                            }

                            $(e).toggleClass("a-hidden", !hit);
                        });
                    }

                    if (filterOptions.noResultsMessage) {
                        this.$el.find("ul.a-vertical-menu").toggleClass("a-filter-noresults", $items.filter(":not(.a-hidden)").length === 0);
                    }

                    this.updateScroller();
                    this.highlightSelected();
                }
            }*/
        }
    }
}
